export const environment = {
  production: true,
  prefix: '/vnm',
  verboseRoutes: false,
  postHogKey: 'phc_tHu7kQ87cBaKF4JOJPM1fXTfogNPuGVaM2AKmyOHGCU'
};
